export default __webpack_public_path__ + "static/media/remove-small-icon.62f7b477.svg";